var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("modal", {
    ref: "popup",
    scopedSlots: _vm._u(
      [
        {
          key: "modal-title",
          fn: function() {
            return [
              _c(
                "h3",
                { staticClass: "dmv-text dmv-text-large dmv-text-primary" },
                [_vm._v(_vm._s(_vm.title))]
              )
            ]
          },
          proxy: true
        },
        {
          key: "modal-body",
          fn: function() {
            return [
              _c(
                "ul",
                { staticClass: "dmv-text" },
                _vm._l(_vm.enumerableTexts, function(text) {
                  return _c("li", { key: text.header }, [
                    _c("span", {
                      staticClass: "dmv-text-medium-large dmv-text-primary",
                      domProps: { innerHTML: _vm._s(text.header) }
                    }),
                    _vm._v(" "),
                    _c("br"),
                    _vm._v(" "),
                    _c("span", {
                      staticClass: "dmv-text-secondary",
                      domProps: { innerHTML: _vm._s(text.body) }
                    })
                  ])
                }),
                0
              )
            ]
          },
          proxy: true
        },
        {
          key: "modal-footer",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "text-right" },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-dark mr-3",
                      on: { click: _vm.hide }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.resource(
                              "DmVisualizer_ConfirmationPopup_CancelButton_Text"
                            )
                          ) +
                          "\n            "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _vm._t("default")
                ],
                2
              )
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }